// Copyright (c) 2016 Deere & Company

export const isHistoryToDisplayInRange = value => value > 0 && value < 10000;



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/services/history-to-display-range-validity.js